<template>
  <div>
    <div class="container-alb filter-mobile">
      <table
        cellpadding="10"
        cellspacing="0"
        width="95%"
        class="hover-table"
        align="center"
      >
                  <tr>
            </tr>
            <tr>
              <td>
                <a
                  class="notification-action"
                  @click="addModifyCampaign()"
                  >{{ $t("orderAddNewRowButtonLabel") }}</a
                >
              </td>
            </tr>

      </table>
    </div>

    <div class="container-alb">

      <!-- campaigns table -->
      <div>
    <table
      cellpadding="10"
      cellspacing="0"
      width="95%"
      class="hover-table invoices-table"
      align="center"
    >
      <thead>
        <tr>
          <td valign="middle">
            <strong>{{ $t("titleLabel") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("categoryField") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("priorityField") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("createNotificationValidity") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("beneficiariesTableAction") }}</strong>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-if="this.campaignsList === null">
          <td colspan="6">
            <div class="loading">
              <img src="@/assets/images/loading.gif" />
            </div>
          </td>
        </tr>
        <template v-for="(campaign, index) in campaignsList">
          <tr
            :key="index"
            class="trhover parent openUserMenu"
            :class="index % 2 === 0 && 'gri-cell'"
            
          >
            <td @click="openCampaignDetails(campaign.id)" valign="middle">
              {{ campaign.i18[0].title }}
            </td>
            <td @click="openCampaignDetails(campaign.id)" valign="middle">
              {{ campaign.category }}
            </td>
            <td @click="openCampaignDetails(campaign.id)" valign="middle">
              {{ campaign.priority }}
            </td>
            <td @click="openCampaignDetails(campaign.id)" valign="middle">
              {{ campaign.start_date + " - " + campaign.end_date }}
            </td>
            <td valign="middle" >
            <a v-if="campaign.status !== 'A'" class="cursor-pointer" title="Modifica" @click="addModifyCampaign(campaign)" >      
                <img class="action-icon" src="@/assets/images/cms-mkt/edit.svg" />
              </a>
               <!-- v-if="campaign.status !== 'A'" -->
              <a v-if="campaign.status !== 'A'"  class="cursor-pointer" title="Aproba" @click="approveCampaignConfirm(campaign)"  >
                 <img class="action-icon" src="@/assets/images/cms-mkt/upload.svg" />
                </a>
              <a class=" cursor-pointer" title="Sterge" @click="deleteCampaignConfirm(campaign)" >
                  <img class="action-icon" src="@/assets/images/cms-mkt/delete.svg" />
                </a>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
  
  <div
  class="error-wrapper border-box"
  v-if="this.campaignsList && this.campaignsList.length === 0"
  >
  <p>{{ $t("noCampaignsInfoMessage") }}</p>
</div>

</div>
    <campaign-details-popup :campaign="this.selectedCampaign"  />
    <new-campaign-popup :campaign="this.selectedCampaignEdit" :categories="this.categories" :widgets="this.widgets" 
        :partners = "this.partners" :locations="this.locations" @showinfo="showPopupInfo" @approve="approveCampaignConfirm"/>
>
    <div id="modal_popup_confirm" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_confirm', false)" class="close-button">
          <img src="@/assets/images/cms-mkt/close-button.svg" />
        </a>
        <br />
        <p>
          {{ $t("confirmDeleteCampaignMessage") }}
        </p>
        <div class="buttons">
          <a href="#" class="yesButton" @click="deleteCampaign()">
            {{ $t("notificationsChooseOptionYes") }}
          </a>
          <a href="#" class="noButton" @click="showModalPopup('modal_popup_confirm', false)">
            {{ $t("notificationsChooseOptionNo") }}
          </a>
        </div>
      </div>
    </div>
    <div id="modal_popup_confirm_approve" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_confirm_approve', false)" class="close-button">
          <img src="@/assets/images/cms-mkt/close-button.svg" />
        </a>
        <br />
        <p v-if="this.selectedCampaign" v-html="$t('confirmApproveCampaignMessage', { start_date: this.selectedCampaign.startDate ? displayDateFormat(this.selectedCampaign.startDate[0]) : this.selectedCampaign.start_date })">
        </p>
        <div class="buttons">
          <a href="#" class="yesButton button-all button-yellow" @click="approveCampaign()">
            {{ $t("cmsLang.approveLabel") }}
          </a>
          <a href="#" class="noButton button-all button-red" @click="showModalPopup('modal_popup_confirm_approve', false)">
            {{ $t("cmsLang.cancelChangesLabel") }}
          </a>
        </div>
      </div>
    </div>
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a
          @click="showModalPopup('modal_popup_info', false)"
          class="close-button"
        >
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.error">
          <p v-for="(error, index) in this.error" :key="index">
          {{ error.description ? error.description : $t('commercialError_' + error.error_code) }}
          </p>
        </div>
         <div v-else>
          <!-- <p v-html="$t('commercialError_' + this.error.code)"></p> -->
        <p v-html="$t(this.successMessage)"></p>
        </div>
      </div>
    </div>
    <!-- <div id="modal_popup_loading" class="modal-popup">
      <div class="modal-popup-content">
        <img src="@/assets/images/loading.gif" />
        <p v-html="$t('loadingPopupMessage')"></p>
      </div>
    </div> -->
  </div>
</template>

<script>
  import httpServiceCommercial from "@/http/http-commercial.js";
  import Cookies from "js-cookie";
  import httpServiceCustomer from "@/http/http-commercial.js";
  import CampaignDetailsPopup from "@/components/fragments/commercial/CampaignDetailsPopup.vue";
  import NewCampaignPopup from "@/components/fragments/commercial/NewCampaignPopup.vue";

  export default {
    props: {
      msg: String,
    },
    components: {
      CampaignDetailsPopup,
      NewCampaignPopup
    },
    data() {
      return {
        campaignsList: [],
        error: null,
        successMessage: null,
        selectedCampaignEdit: null,
        selectedCampaign: null,
        action: "",
        locations: null,
        partners: null,
        categories: ["vouchers", ""],
        widgets: ["interstitial", "dashboard"]
      };
    },
    methods: {
      productSelected(event) {
        this.filters.product = event.target.value;
        this.getCampaigns();
      },
      isSelectedProduct(product) {
        return product === this.filters.product;
      },
      sortBy(sortField, sortDirection, status) {
        this.sortField = sortField;
        this.sortDirection = sortDirection;
        this.getCampaigns(status);
      },
      showModalPopup(elementId, show) {
        if (show) {
          document.getElementById(elementId).style.visibility = "visible";
        } else {
          document.getElementById(elementId).style.visibility = "hidden";
        }
      },
      getCampaigns() {
        this.error = null;
        this.showModalPopup("modal_popup_loading", true);

        httpServiceCommercial.customerService
          .searchCampaigns("", Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {

            if (response.status == 200) {
              this.campaignsList = response.data;
            } else if (response.status == 400) {
              this.error = [{ error_code: response.data.error_code }];
            } else {
              this.error = [{ error_code: response.error_code }];
            }
            if (this.error) {
              this.showModalPopup("modal_popup_info", true);
            }
            this.showModalPopup("modal_popup_loading", false);
          })
      },
      getLocations() {
        this.error = null;

        httpServiceCommercial.customerService
          .getLocations("", Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {

            if (response.status == 200) {
              this.locations = response.data;
            } else if (response.status == 400) {
              this.error = { code: response.data.error_code };
            } else {
              this.error = { code: response.error_code };
            }
          })
      },
      getPartners() {
        this.error = null;

        httpServiceCommercial.customerService
          .getPartners(Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {

            if (response.status == 200) {
              this.partners = response.data;
            } else if (response.status == 400) {
              this.error = { code: response.data.error_code };
            } else {
              this.error = { code: response.error_code };
            }
          })
      },
      openCampaignDetails(campaignId) {
        this.action = "details";
        this.getCampaignDetails(campaignId);
      },
      getCampaignDetails(campaignId) {
        this.showModalPopup("modal_popup_loading", true);
        this.selectedCampaignEdit = {};

        httpServiceCommercial.customerService
          .getCampaign(campaignId, Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {
            if (response.status === 200) {
              this.selectedCampaignEdit = response.data;

              
              this.showModalPopup("modal_popup_campaign", true);
            } else {
              
              this.error = [{
                error_code: response.data.error_code,
              }];
              this.showModalPopup("modal_popup_info", true);
            }
            this.showModalPopup("modal_popup_loading", false);
          });
      },
      selectProduct(index) {
        this.selectedProduct = this.cardProducts[index];
      },

      deleteCampaignConfirm(campaign) {
        this.selectedCampaign = campaign;
        this.showModalPopup("modal_popup_confirm", true);
      },
      deleteCampaign() {
        console.log("delete");
        this.successMessage = "";
        this.error = null;
        this.showModalPopup("modal_popup_loading", true);

        httpServiceCustomer.customerService
          .deleteCampaign(
            this.selectedCampaign.id,
            Cookies.get("token")
          )
          .catch((error) => {
            return error.response;
          })
          .then((response) => {
            if (response.status == 200 || response.status == 204 || response.status == 202) {
              this.getCampaigns();
              this.showPopupInfo("campaignDeleteSuccess", null);
            } else {
              if (response) {
                this.error = { code: response.status };
              } else {
                this.error = { code: "500" };
              }
              this.showPopupInfo("", this.error);
            }
            this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_confirm", false);

          })
      },
      approveCampaignConfirm(campaign) {
        this.selectedCampaign = campaign;
        this.showModalPopup("modal_popup_confirm_approve", true);
      },
      approveCampaign() {
        this.showModalPopup("modal_popup_loading", true);
        httpServiceCustomer.customerService
          .publishCampaign(
            this.selectedCampaign,
            Cookies.get("token")
          )
          .catch((error) => {
            return error.response;
          })
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              this.showPopupInfo("campaignPublishSuccess", null);
            } else {
              if (response) {
                this.error = response.data;
              } else {
                this.error = { code: "500" };
              }
              this.showPopupInfo("", this.error);
              this.showModalPopup("modal_popup_confirm_approve", false);
            }

          })
      },
      showPopupInfo(successMessage, error) {
        this.successMessage = successMessage;
        this.error = error;
        // this.showModalPopup("modal_popup_partners", false);
        if (this.error === null) {        
          this.showModalPopup("modal_popup_campaign", false);
        }
        this.showModalPopup("modal_popup_loading", false);
        this.showModalPopup("modal_popup_info", true);
      },
      addModifyCampaign(campaign) {
        this.action = "edit"
        this.error = null;
        this.showModalPopup("modal_popup_campaign_details", false);
        this.selectedCampaignEdit = null;
        if (!campaign) {
          this.selectedCampaignEdit = {
            id: 0,
          };
          this.showModalPopup("modal_popup_campaign", true);
          // }
        } else {
          this.getCampaignDetails(campaign.id);
        }
      },
      displayDateFormat(dateUnformatted) {
        return moment(dateUnformatted).format('DD-MM-YYYY');
      },
    },
    mounted() {
      this.getLocations();
      this.getPartners();
      this.getCampaigns();
    },
  };
</script>

<style scoped src="@/assets/styles/beneficiary.css"></style>
<style>
  .page-link {
    color: #4a4a4a;
  }

  .page-link:hover {
    color: #4e5b59;
  }

  .page-item.active .page-link {
    background-color: #4e5b59 !important;
    border-color: #4e5b59 !important;
  }

  .invoices-filter .reportrange-text {
    height: 27px;
    font-size: 13px;
    padding: 3px 10px;
    border: none !important;
    color: #585858;
    background: #f1f1f1;
  }

  .action-icon {
    margin-right: 25px;
    ;
  }
</style>
